import axios from "axios";

export const sellerData = () => {
    return axios
      .get("/best_seller")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };